<div class="cej-advantages">
  <app-cej-v2-what-are-we-doing></app-cej-v2-what-are-we-doing>

  <app-cej-v2-can-i-benefit (clickButton)="canBenefitButtonClick.emit()"></app-cej-v2-can-i-benefit>

  <app-cej-v2-what-do-i-gain></app-cej-v2-what-do-i-gain>
</div>
